export const TABSKEY = {
  line: 'line',
  station: 'station'
}

export const STATIONCOLUMN = [
  {
    title: "站点编码",
    dataIndex: "stationCode",
    minWidth: 240,
  },
  {
    title: "站点ID",
    dataIndex: "stationId",
    minWidth: 240,
  },
  {
    title: "站点名称",
    dataIndex: "stationName",
    minWidth: 240,
  },
  {
    title: "位置信息",
    dataIndex: "stationLoc",
    scopedSlots: { customRender: "stationLoc" },
    minWidth: 260,
  },
  {
    title: "站点地址",
    dataIndex: "stationAddress",
    scopedSlots: { customRender: "stationAddress" },
    minWidth: 200,
  },
  // {
  //   title: "city_name_real",
  //   dataIndex: "cityNameReal",
  //   width: 140,
  // },
  {
    title:'操作',
    dataIndex: "active",
    scopedSlots: { customRender: "action" },
    width:180,
    fixed:'right'
  }
]

export const LINECOLUMN = [
  {
    title: "线路名称",
    dataIndex: "route",
    minWidth: 180,
  },
  {
    title: "始发仓城市",
    dataIndex: "startCity",
    minWidth: 180,
  },
  {
    title: "始发仓",
    dataIndex: "startWarehouse",
    scopedSlots: { customRender: "startWarehouse" },
    minWidth: 200,
  },
  {
    title: "目的仓城市",
    dataIndex: "endCity",
    minWidth: 180,
  },
  {
    title: "目的仓",
    dataIndex: "endWarehouse",
    scopedSlots: { customRender: "endWarehouse" },
    minWidth:200
  },
  {
    title: "车型",
    dataIndex: "truckType",
    minWidth: 120,
  },
  {
    title: "价格(元)",
    dataIndex: "quotedPrice",
    minWidth: 120,
  },
  {
    title: "时效",
    dataIndex: "aging",
    minWidth: 120,
  },
  {
    title: "审批状态",
    dataIndex: "approvalStatus",
    scopedSlots: { customRender: "approvalStatus" },
    minWidth: 120,
  },
  {
    title: "满载率",
    dataIndex: "loadF",
    scopedSlots: { customRender: "loadF" },
    minWidth: 120,
  },
  {
    title: "区域",
    dataIndex: "area",
    minWidth: 120,
  },
  {
    title:'操作',
    dataIndex: "active",
    scopedSlots: { customRender: "action" },
    width:180,
    fixed:'right'
  }
]

export const CARTYPELIST = [
  {
    id: '7.6米',
    name: '7.6米'
  },
  {
    id: '9.6米',
    name: '9.6米'
  },
  {
    id: '12.5米',
    name: '12.5米'
  },
  {
    id: '13.5米',
    name: '13.5米'
  },
  {
    id: '15米',
    name: '15米'
  },
]


export const APPROVAL={
    APPROVED:'APPROVED',
    NO_APPROVAL:'NO_APPROVAL'
  }

export const APPROVAL_TYPE={
  APPROVED:'已审核',
  NO_APPROVAL:'未审核'
}